import { render, staticRenderFns } from "./MicrosoftLoading.vue?vue&type=template&id=2bad4422&scoped=true&"
import script from "./MicrosoftLoading.vue?vue&type=script&lang=js&"
export * from "./MicrosoftLoading.vue?vue&type=script&lang=js&"
import style0 from "./MicrosoftLoading.vue?vue&type=style&index=0&id=2bad4422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bad4422",
  null
  
)

component.options.__file = "MicrosoftLoading.vue"
export default component.exports